import { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from 'store/store.inteface';
import { Loading } from 'pages/Franchisee/TimelineActions/DocumentRequest/Loading';
import { getKnowledgePortalAction } from 'store/modules/portal/actions';
import { Wrapper, Title } from './styles';
import { DownloadMultipleButton } from './downloadButton';
import { NoContent } from './NoContent';
import { TablePortal } from './components/Table';

export interface PortalWrapperProps {
  title: string;
}

export const PortalWrapper = ({ title }: PortalWrapperProps) => {
  const { stores } = useSelector(
    (state: ApplicationState) => state.storesContext,
  );
  const { portal, error } = useSelector(
    (state: ApplicationState) => state.portal,
  );
  const [loading, setLoading] = useState(true);
  const [selected, setSelected] = useState([]);
  const dispatch = useDispatch();

  const franchiseCode = stores.map(({ code }) => code).slice(0, 100);

  function handleSelect(id) {
    setSelected(prevSelected => {
      const newSelection = { id };
      const isSelected = prevSelected.some(selection => selection.id === id);

      if (isSelected) {
        return prevSelected.filter(selection => selection.id !== id);
      }
      return [...prevSelected, newSelection];
    });
  }

  const filesSelected = selected.map(selection => selection.id);

  const fetchPortal = useCallback(
    franchise => {
      dispatch(getKnowledgePortalAction(franchise));
    },
    [dispatch],
  );

  const getPortal = useCallback(() => {
    if (stores.length > 0) {
      const codeString = JSON.stringify(franchiseCode);
      fetchPortal(codeString);
    }
  }, [stores, fetchPortal]);

  useEffect(() => {
    getPortal();
  }, [getPortal]);

  useEffect(() => {
    setLoading(false);
    if (
      (portal.response.length === 0 && error === null) ||
      stores.length === 0
    ) {
      setLoading(true);
    }
  }, [portal, error, stores]);

  return (
    <Wrapper>
      <header>
        <Title>{title}</Title>
        <div
          className="header-content"
          style={{ display: 'flex', alignItems: 'center', gap: '12px' }}
        >
          <DownloadMultipleButton
            selected={filesSelected}
            franshiceCode={franchiseCode}
          />
        </div>
      </header>
      {!error && (
        <TablePortal
          files={portal}
          selected={selected}
          handleSelect={id => handleSelect(id)}
        />
      )}
      {loading && <Loading />}
      {error && <NoContent error={error} />}
    </Wrapper>
  );
};
